import { Component, OnInit, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { error } from 'src/app/_helpers/error';
import { User } from '../../models/user.model';
import { AuthService } from '../../services/auth.service';
import { Title, Meta } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';


@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {

  submitted: boolean = false;
  error = error.err;

  constructor(
    private authService: AuthService,
    private router: Router,
    private toastr: ToastrService,
    private titleService: Title,
    private meta: Meta,
    @Inject(DOCUMENT) private doc: Document
  ) { }


  ngOnInit() {
    this.titleService.setTitle('Sign In | Buyer & Seller Access \u2013 Al Qaryah Cars Auction');
    
    this.meta.updateTag({
      name: 'description',
      content: 'Sign in to Al Qaryah Cars Auction to buy, sell, bid, and monitor vehicle auctions in real time through a simple, secure platform. Manage listings easily…'
    });

    this.meta.updateTag({
      name: 'keywords',
      content: 'al qaryah terms and condition, sharjah auto auction, al qaryah auction, terms and conditions, Used cars in auction, uae car auction, auction cars in dubai, auction cars dubai, cars auction dubai, auction process, auction registration, auction approval, cars in sharjah, sharjah used car market, cheap cars for sale in uae, used cars in sharjah, luxury car auctions near me, classic cars auction, collector car auctions, classic car auctions online, sharjah cars, sharjah auction laws, car approval timing, auction car approval, cars auction sharjah, auction, cars auction'
    });

    this.meta.updateTag({
      name: 'author',
      content: 'Al Qaryah Auction'
    });

    this.meta.updateTag({
      name: 'publisher',
      content: 'Al Qaryah Auction'
    });

    this.meta.updateTag({
      name: 'robots',
      content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
    });

    this.meta.updateTag({
      property: 'og:title',
      content: 'Sign In | Buyer & Seller Access \u2013 Al Qaryah Cars Auction'
    });

    this.meta.updateTag({
      property: 'og:description',
      content: 'Sign in to Al Qaryah Cars Auction to buy, sell, bid, and monitor vehicle auctions in real time through a simple, secure platform. Manage listings easily…'
    });

    this.meta.updateTag({
      property: 'og:type',
      content: 'website'
    });

    this.meta.updateTag({
      name: 'twitter:card',
      content: 'summary_large_image'
    });

    this.meta.updateTag({
      name: 'twitter:title',
      content: 'Sign In | Buyer & Seller Access \u2013 Al Qaryah Cars Auction'
    });

    this.meta.updateTag({
      name: 'twitter:description',
      content: 'Sign in to Al Qaryah Cars Auction to buy, sell, bid, and monitor vehicle auctions in real time through a simple, secure platform. Manage listings easily…'
    });

    this.setCanonicalURL('https://alqaryahauction.com/vehicle');
  }

  setCanonicalURL(url: string): void {
    let link: HTMLLinkElement = this.doc.querySelector("link[rel='canonical']") || null;
    if (link) {
      link.setAttribute('href', url);
    } else {
      link = this.doc.createElement('link');
      link.setAttribute('rel', 'canonical');
      link.setAttribute('href', url);
      this.doc.head.appendChild(link);
    }
  }
}
